// extracted by mini-css-extract-plugin
export var actionButton = "_b7-1";
export var actionButtons = "_b7-2";
export var actions = "_b7-0";
export var aiUnread = "_b7-10";
export var alignCenter = "_b7-h";
export var backWrapper = "_b7-3";
export var cellContainer = "_b7-4";
export var checkboxContainer = "_b7-5";
export var contentContainer = "_b7-6";
export var contentHeader = "_b7-8";
export var conversationsTableWrapper = "_b7-s";
export var draftReplyBadgeContainer = "_b7-m";
export var dropdownItem = "_b7-b";
export var dropdownItemsContainer = "_b7-a";
export var dropdownTitle = "_b7-c";
export var errorIcon = "_b7-7";
export var filter = "_b7-d";
export var gray = "_b7-i";
export var headerActionButtons = "_b7-e";
export var headerCheckboxContainer = "_b7-f";
export var icon = "_b7-j";
export var menuContainer = "_b7-k";
export var noMoreTicketsIcon = "_b7-12";
export var noMoreTicketsSubText = "_b7-13";
export var oneLine = "_b7-l";
export var optionsButton = "_b7-n";
export var plus = "_b7-o";
export var portalButtonsWrapper = "_b7-g";
export var red = "_b7-p";
export var scrolledTop = "_b7-9";
export var search = "_b7-q";
export var selectedConversationsCount = "_b7-r";
export var spinner = "_b7-t";
export var strong = "_b7-u";
export var summaryCell = "_b7-v";
export var tableContainer = "_b7-11";
export var tagContainer = "_b7-w";
export var threeDots = "_b7-x";
export var twoLines = "_b7-y";
export var unread = "_b7-z";